import { FIELD_TYPES } from "constants/template-field-type";
import PricesAndFeaturesCardsPricing from "../prices-and-features-cards-pricing/index.js";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Expandable Products Pricing",
    fields: {
        productTitles: {
            type: FIELD_TYPES.NESTED,
            label: "Product Titles",
            fields: {
                crm: {
                    type: FIELD_TYPES.TEXT,
                    label: "CRM product title",
                    translatable: true
                },
                service: {
                    type: FIELD_TYPES.TEXT,
                    label: "Service product title",
                    translatable: true
                },
                software: {
                    type: FIELD_TYPES.TEXT,
                    label: "Dev (software) product title",
                    translatable: true
                }
            }
        },
        pricesAndFeaturesCardsPricing: PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingConfig
    }
};
